import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  NgbCalendar,
  NgbDateStruct,
  NgbDatepickerConfig,
} from '@ng-bootstrap/ng-bootstrap';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css'],
})
export class SignUPComponent implements OnInit {
  step1: boolean = true;
  step2: boolean = false;
  step3: boolean = false;
  step4: boolean = false;

  signupDisabled = false;
  resendEmail = false;
  emailMessage: string = '';

  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDay();
  minDate = moment({
    day: this.day,
    month: this.month,
    year: this.year - 50,
  }).format('DD-MM-YYYY');
  maxDate = moment({
    day: this.day,
    month: this.month,
    year: this.year - 10,
  }).format('DD-MM-YYYY');

  form: UntypedFormGroup;

  role: string = 'Student';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  mobile: string = ''; //Not Used
  dob: any;
  heardFrom: string = '';
  address: string = '';
  city: string = '';
  school: string = '';
  grade: string = '';
  educationName: string = '';
  experience: string = '';
  resume: File | null = null;
  guardianName: string = '';
  guardianRelation: string = '';
  guardianMobile: string = ''; //Not Used
  packageId: string = '';
  courses: any = [];
  selectedCourses: string[] = [];

  resumeFileExtensions: string[] = [
    'application/pdf',
    'application/doc',
    'application/docx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];

  keyword = 'name';
  data: any[] = [];
  cities: string[] = [
    'Ahmadpur East',
    'Ahmed Nager Chatha',
    'Ali Khan Abad',
    'Alipur',
    'Arifwala',
    'Attock',
    'Bhera',
    'Bhalwal',
    'Bahawalnagar',
    'Bahawalpur',
    'Bhakkar',
    'Burewala',
    'Chenab Nagar',
    'Chillianwala',
    'Choa Saidanshah',
    'Chakwal',
    'Chak Jhumra',
    'Chichawatni',
    'Chiniot',
    'Chishtian',
    'Chunian',
    'Dajkot',
    'Daska',
    'Davispur',
    'Darya Khan',
    'Dera Ghazi Khan',
    'Dhaular',
    'Dina',
    'Dinga',
    'Dhudial Chakwal',
    'Dipalpur',
    'Faisalabad',
    'Fateh Jang',
    'Ghakhar Mandi',
    'Gojra',
    'Gujranwala',
    'Gujrat',
    'Gujar Khan',
    'Harappa',
    'Hafizabad',
    'Haroonabad',
    'Hasilpur',
    'Haveli Lakha',
    'Islamabad',
    'Jalalpur Jattan',
    'Jampur',
    'Jaranwala',
    'Jhang',
    'Jhelum',
    'Jauharabad',
    'Kallar Syedan',
    'Kalabagh',
    'Karor Lal Esan',
    'Karachi',
    'Kasur',
    'Kamalia',
    'Kāmoke',
    'Khanewal',
    'Khanpur',
    'Khanqah Sharif',
    'Kharian',
    'Khushab',
    'Kot Adu',
    'Lahore',
    'Lalamusa',
    'Layyah',
    'Lawa Chakwal',
    'Liaquat Pur',
    'Lodhran',
    'Malakwal',
    'Mamoori',
    'Mailsi',
    'Mandi Bahauddin',
    'Mian Channu',
    'Mianwali',
    'Miani',
    'Multan',
    'Murree',
    'Muridke',
    'Mianwali Bangla',
    'Muzaffargarh',
    'Narowal',
    'Nankana Sahib',
    'Okara',
    'Pakpattan',
    'Pattoki',
    'Pindi Bhattian',
    'Pind Dadan Khan',
    'Pir Mahal',
    'Qaimpur',
    'Qila Didar Singh',
    'Raiwind',
    'Rajanpur',
    'Rahim Yar Khan',
    'Rawalpindi',
    'Renala Khurd',
    'Sadiqabad',
    'Sagri',
    'Sahiwal',
    'Sambrial',
    'Samundri',
    'Sangla Hill',
    'Sarai Alamgir',
    'Sargodha',
    'Shakargarh',
    'Sheikhupura',
    'Shujaabad',
    'Sialkot',
    'Sohawa',
    'Soianwala',
    'Siranwali',
    'Tandlianwala',
    'Talagang',
    'Taxila',
    'Toba Tek Singh',
    'Vehari',
    'Wah Cantonment',
    'Wazirabad',
    'Yazman',
    'Zafarwal',
  ];
  packages: any = [];
  currentDate: any;

  constructor(
    private toastr: ToastrService,
    private http: HttpClient,
    private authService: AuthService,
    private calendar: NgbCalendar,
    private config: NgbDatepickerConfig,
    private fb: UntypedFormBuilder
  ) {
    this.form = fb.group({
      phone: ['', [Validators.required]],
      guardianPhone: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    const current = new Date();
    this.currentDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
    this.cities.forEach((city) => {
      this.data.push({ id: city, name: city });
    });
    this.getCourses();
  }

  getCourses() {
    this.http
      .get(environment.reqBaseUrl + 'packages/courses', { observe: 'response' })
      .subscribe((res) => {
        this.courses = res.body;
      });
  }

  checkEmail() {
    var emailRegex: RegExp = RegExp(
      '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$'
    );
    if (emailRegex.test(this.email)) {
      this.authService.checkEmail(this.email.trim()).subscribe((res) => {
        var user: any = res.body;
        if (user && user.isActive == 'R') {
          this.resendEmail = true;
          this.emailMessage = '';
          this.signupDisabled = true;
        } else if (user && user.isActive == 'V') {
          //pending approval
          this.resendEmail = false;
          this.signupDisabled = true;
          this.emailMessage =
            'This account is in use and pending approval by the Admin.';
        } else if (user && (user.isActive == 'Y' || user.isActive == 'D')) {
          //already registered
          this.resendEmail = false;
          this.signupDisabled = true;
          this.emailMessage = 'Email is already in use.';
        } else {
          this.resendEmail = false;
          this.signupDisabled = false;
          this.emailMessage = '';
        }
      });
    }
  }

  ResendEmail() {
    this.toastr.info('Sending Verification Email');
    this.authService.resendEmail(this.email.trim()).subscribe((res) => {
      this.toastr.clear();
      this.toastr.success('Email Sent');
    });
  }

  addCourse(courseName: any) {
    this.selectedCourses.pop();
    this.selectedCourses.push(courseName.target.value);
  }

  // setResume(file: File) {
  //   this.resume = file;
  // }
  setResume(file: any) {
    this.resume = file.target.files.item(0);
  }

  veifyData() {
    var error = '';
    if (this.firstName.trim() == '') {
      error = 'First Name is Required.';
    } else if (this.lastName.trim() == '') {
      error = 'Last Name is Required.';
    } else if (this.email.trim() == '') {
      error = 'Email is Required.';
    } else if (this.address.trim() == '') {
      error = 'Address is Required.';
    } else if (this.city.trim() == '') {
      error = 'City is Required.';
    } else if (!this.form.value.phone.trim()) {
      error = 'Mobile Number is Required.';
    } else if (this.form.value.phone.length < 12) {
      error = 'Mobile Number is not complete.';
    } else if (this.dob == null) {
      error = ' Date of Birth is required.';
    } else if (this.heardFrom.trim() == '') {
      error = 'Tell us where you got to know about us from.';
    }
    // fields for Teacher
    else if (this.role != 'Student' && this.educationName.trim() == '') {
      error = 'Education Name is required.';
    } else if (
      this.role != 'Student' &&
      this.experience == '' &&
      +this.experience != 0
    ) {
      error = 'Work Experience is required.';
    } else if (this.role != 'Student' && !this.resume) {
      error = 'Resume is required.';
    } else if (
      this.role != 'Student' &&
      this.resume &&
      !this.resumeFileExtensions.includes(this.resume.type)
    ) {
      error = "Please Upload 'PDF' or 'DOC' File for resume.";
    }
    // fields for Student
    else if (this.role == 'Student' && this.school.trim() == '') {
      error = 'School name is required.';
      // } else if (this.role == 'Student' && this.grade.trim() == ''){
      //   error = "Grade is required."
    } else if (this.role == 'Student' && this.guardianName.trim() == '') {
      error = 'Guardian Name is required.';
    } else if (this.role == 'Student' && this.guardianRelation.trim() == '') {
      error = 'Relation to Guardian is required.';
    } else if (
      this.role == 'Student' &&
      !this.form.value.guardianPhone.trim()
    ) {
      error = 'Guardian Mobile Number is required.';
    } else if (
      this.role == 'Student' &&
      this.form.value.guardianPhone.length < 12
    ) {
      error = 'Guardian Mobile Number is not complete.';
    } else if (this.role == 'Student' && !this.selectedCourses.length) {
      error = 'Select class/Grade.';
    }
    if (error) {
      this.toastr.info(error);
    } else {
      // if(this.role == 'Student') {
      //   this.ActivateStep3();
      // } else {
      this.ActivateStep4();
      // }
    }
  }

  signUp() {
    this.toastr.info('Creating Your Account.');
    this.signupDisabled = true;
    var courses: string = '';
    this.selectedCourses.forEach((course) => {
      courses = courses + course + ', ';
    });
    courses = courses.slice(0, courses.lastIndexOf(','));

    var payload = new FormData();
    payload.append('role', this.role);
    payload.append('firstName', this.firstName);
    payload.append('lastName', this.lastName);
    payload.append('email', this.email);
    // if (this.dob && this.dob.day && this.dob.month && this.dob.year) {
    //   payload.append(
    //     'dob',
    //     this.dob.day + '-' + this.dob.month + '-' + this.dob.year
    //   );
    // } else {
    //   error: 'Date of birth is required *';
    // }
    payload.append(
      'dob',
      this.dob.day + '-' + this.dob.month + '-' + this.dob.year
    );
    payload.append('address', this.address);
    payload.append('city', this.city);
    payload.append('state', 'Punjab');
    payload.append('phone', this.form.value.phone);
    payload.append('schoolName', this.school);
    payload.append('cameFrom', this.heardFrom);
    payload.append('education', this.educationName);
    payload.append('experience', this.experience);
    payload.append('guardianName', this.guardianName);
    payload.append('guardianRelation', this.guardianRelation);
    payload.append('guardianPhone', this.form.value.guardianPhone);
    payload.append('packageId', this.packageId);
    // payload.append("grade", this.grade);
    payload.append('grade', courses);
    payload.append('courses', courses);
    if (this.resume) {
      payload.append('resume', this.resume);
    }
    this.authService.signUp(payload).subscribe((res) => {
      this.step1 = false;
      this.step2 = false;
      this.step3 = false;
      this.step4 = true;
      // this.toastr.clear();
      this.toastr.success(
        'A confirmation mail has been sent to provided email.'
      );
    });
  }

  ActivateStep1() {
    this.step1 = true;
    this.step2 = false;
    this.step3 = false;
    this.step4 = false;
  }
  ActivateStep2() {
    this.step1 = false;
    this.step2 = true;
    this.step3 = false;
    this.step4 = false;
  }
  ActivateStep3() {
    this.step1 = false;
    this.step2 = false;
    this.step3 = true;
    this.step4 = false;
  }
  ActivateStep4() {
    this.step1 = false;
    this.step2 = false;
    this.step3 = false;
    this.step4 = true;
    this.signUp();
  }
}
